import { useContext } from 'react';
import { UserProfileContext } from './UserProfileContext';
import type { UserProfileContextValue } from './UserProfileContext';

export const useUserProfile = (): UserProfileContextValue => {
  const context = useContext(UserProfileContext);
  if (!context) {
    throw new Error('useUserProfile must be used within UserProfileProvider');
  }
  return context;
};
